import { render, staticRenderFns } from "./CardUsefulFiles.vue?vue&type=template&id=0cde3b18"
import script from "./CardUsefulFiles.vue?vue&type=script&lang=ts"
export * from "./CardUsefulFiles.vue?vue&type=script&lang=ts"
import style0 from "./CardUsefulFiles.vue?vue&type=style&index=0&id=0cde3b18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports